export default __webpack_public_path__ + "static/media/illustration-australia.1293a65c.svg";